import { OnInit } from "@angular/core";
import { Router, NavigationStart } from '@angular/router';

import { IssuesService, IssueSearchSpec, SearchSpecPaging, OrderParameters } from "../../../../common/services/issues.service";
//import { IDatasource, IGetRowsParams, GridOptions, IServerSideDatasource, IServerSideGetRowsParams } from '@ag-grid-enterprise/all-modules';
import { GridApi, GridOptions, IServerSideDatasource, IServerSideGetRowsParams } from "ag-grid-community";

import { Issue } from "../../../../common/models/issue.model";
import { Subscription, Observable, of } from "rxjs";
import { filter, finalize } from "rxjs/operators";

export class IssuesDataSource implements IServerSideDatasource {

    rowCount?: number;
    subscriptions: Subscription = new Subscription();

    getRows(params: IServerSideGetRowsParams): void {
        let numberOfItemsToReturn = params.request.endRow - params.request.startRow;

        params.request.filterModel

        //Set the paging parameters
        this.searchSpec.pagingCriteria = {
            numberOfItemsToReturn: numberOfItemsToReturn,
            startingIndex: params.request.startRow
            } as SearchSpecPaging;

        if (params.request.filterModel != null && params.request.filterModel != undefined)
            this.searchSpec.filters = params.request.filterModel;

        if (params.request.sortModel && params.request.sortModel.length > 0)
            this.searchSpec.ordering= {
                ascending: params.request.sortModel[0].sort == "asc",
                field: params.request.sortModel[0].colId
            } as OrderParameters
        this.subscriptions.add(this.issuesSvc.getIssues(this.searchSpec).subscribe(
            data => {
                let lastRow = -1;
                if (data.length < numberOfItemsToReturn) {
                    lastRow = data.length;
                }
				params.success({ rowData: data, rowCount: lastRow });
                this.api.sizeColumnsToFit();
            },
            error => { console.log(error); alert("ERROR Fetching Issues"); }
        ));
    }

    destroy?(): void {
        this.subscriptions.unsubscribe();
    }

    constructor(
        public readonly issuesSvc: IssuesService,
        public api: GridApi,
        public searchSpec: IssueSearchSpec = null,
        public router: Router
    ) {
        if (this.searchSpec == null || this.searchSpec == undefined)
            this.searchSpec = {
                loadChildren: false,
            } as IssueSearchSpec;

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

}
